import {UserGuide} from '@/pages/Template/components/HeaderExtraItems'
export default function NoCountriesPage(): React.JSX.Element {
  return (
    <div
      className="shadow mb-6 mt-2 flex h-full w-full overflow-y-auto rounded-lg border-none bg-layer-01 p-6"
      data-testid="no-countries-page"
      data-cy="no-countries-page"
    >
      <div>You do not have any countries assigned. Please follow the instructions to request access.</div>
      <div className="-ml-2 -mt-2">
        <UserGuide iconColor="text-black" openAccordionIndex={7} />
      </div>
    </div>
  )
}
